import React from 'react';

import SectionLayout from 'dpl/quiz/components/SectionLayout';
import { SECTION_CLASSES } from 'dpl/quiz/sections/components/Section';

export default function TelephoneSection(props) {
  return (
    <div className={SECTION_CLASSES}>
      <div>
        <SectionLayout {...props} />
        <p className="SectionSubtext ph5 f1 tertiary tc mt3 mb3">
          By clicking &lsquo;Continue&rsquo;, you consent to receive service and
          offer-related text messages from Good Dog at the number provided, like
          when a breeder sends you a message. Messages may be sent using
          automated systems for the selection and dialing of numbers. Consent is
          not a condition of any purchase. Reply STOP to unsubscribe any time.
          Message and data rates may apply.
        </p>
      </div>
    </div>
  );
}
